import React, { Component, PropTypes } from 'react';

import { CodeSplit } from 'code-split-component';
import { Loading } from '@beisen/chaos-ui';
import * as helper from '../util/helper';

export default class Widget extends Component {
	static contextTypes = {
		actions: PropTypes.object.isRequired
	}
	constructor(props,context) {
		super(props,context);
		this.actions =  props.actions;
		this.state = {
			width: '100%',
			height: this.props.height || this.calDefaultIframeHeight(),
			highchartsData: props.chartData
		};
		this.viewMode = (typeof this.props.viewMode == 'undefined' && this.props.cmp_data && this.props.cmp_data['highcharturl']) ? 'highcharts' : 'report';
	}

	calDefaultIframeHeight() {
		if(window.env.platform.beisenApp && helper.ifHidePopupNav()) {
			return window.innerHeight + 'px';
		}

		return window.innerHeight - 44 + 'px';
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps['chartData']) {
			this.setState({ highchartsData: nextProps['chartData'] });
		}
	}

	componentDidMount() {
		let { cmp_id, message } = this.props;
		if(message && message.send && this.props.viewMode == 'report') {
			this.refs[cmp_id].contentWindow.name = JSON.stringify(message.content || {});
		}
		if(this.viewMode == 'highcharts') {
			this.props.actions.fetchDashBordData(this.props.cmp_data['highcharturl'], '', this.props.cmp_id);
		}
	}


    shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.visible &&
				(nextProps.viewMode == 'highcharts' || this.viewMode == 'highcharts'
					? !!nextProps['chartData'] && nextProps['chartData'] != this.props['chartData']
					: true)) || (!nextProps.visible && !!nextProps['chartData']);
	}

	componentDidUpdate(nextProps) {
		let { cmp_id, message } = this.props;
		if(message && message.send && window.iTalentSDK) {
			window.iTalentSDK.sendMessage({
	            publishEvent: cmp_id,
	            data: {
	                type: message.action,
	                params: message.content || {}
	            }
	        });
		}
	}

    extendUrlParams(urlDynamicParam) {
		let str = '';
		for(let prop in urlDynamicParam) {
			if(urlDynamicParam.hasOwnProperty(prop)) {
				str += '&' + prop + '=' + urlDynamicParam.prop;
			}
		}
		return `${str}&height=${this.state.height}&_width=${window.innerWidth}px&_isMobile=true`;
	}

	getSymbol(url) {
		return url.indexOf('?') >= 0 ? '&' : '?';
	}

    renderHighcharts() {
        if(!this.state.highchartsData) {
            return null;
        }
		// getHigncharts().then((ReactHighcharts)=>{
		return (
			<CodeSplit chunkName="ReactHigncharts" modules={{ ReactHighcharts: require('@beisen/react-highcharts') }} defer={false}>
				{({ ReactHighcharts }) => ReactHighcharts ? (<ReactHighcharts config={Object.assign(this.state.highchartsData || {}, { credits: { enabled: false }, exporting: { enabled: false } })}
							domProps={{ style: { height: '100%' } }} />) : <Loading />}
			</CodeSplit>
		);
    }

    renderWidget() {
		let { cmp_data, cmp_id, urlDynamicParam, cmp_type } = this.props;
		let IframeUrl = cmp_data && cmp_data.url;

		if(cmp_type == 'CustomWidget') {
			IframeUrl = cmp_data.mobileurl;
		}

		if(!IframeUrl) {
			return;
		}
		IframeUrl = helper.addShadowContextUrl(IframeUrl);
		const decodeUrl = decodeURIComponent(IframeUrl);
		const params = 'WidgetEvent=' + cmp_id + this.extendUrlParams(urlDynamicParam);

		const hash = decodeUrl.split('#/')[1];
		const url = decodeUrl.split('#/')[0];
		// 如果URL上有路由并且路由后没有 ? 参数 则将参数追加到 #/前面
		if(decodeUrl.indexOf('#/') >= 0) {
			IframeUrl = (hash.indexOf('?') > -1) ? `${IframeUrl}&${params}` : `${url}${this.getSymbol(url)}${params}#/${hash}`;
		}else {
			IframeUrl = `${IframeUrl}${this.getSymbol(decodeUrl)}${params}`;
		}


		return (
			<iframe height={this.state.height}
					id={this.props.id}
					key={this.props.cmp_id}
			        ref={this.props.cmp_id}
					src={IframeUrl}
					style={{ 'border': 'none','width': this.state.width }}
			/>
		);
    }

	render() {
		if(this.props.viewMode == 'highcharts' || this.viewMode == 'highcharts') {
			return this.renderHighcharts();
		}

		return this.renderWidget();
	}
}



// WEBPACK FOOTER //
// ./src/components/IframeWidget/Widget.js